import React from 'react';
import { AlertCircle } from 'lucide-react';

export const SponsoredLabel = ({ placement = 'top' }) => {
  const positionClass = placement === 'top' 
    ? 'mb-4' 
    : 'mt-4';

  return (
    <div className={`flex items-center gap-2 bg-yellow-50 border-l-4 border-brand-yellow px-4 py-2 ${positionClass}`} data-testid="sponsored-label">
      <AlertCircle className="w-4 h-4 text-brand-yellow" />
      <span className="text-sm font-inter font-medium text-gray-700">
        <span className="font-bold text-brand-yellow">SPONSORED POST</span> - This article contains affiliate links and sponsored content
      </span>
    </div>
  );
};
